import React from 'react'
import styled, { css } from 'styled-components'

import { Loader } from '../../atoms/loader'

export const StyledDiv1 = styled.div`
background-color: white;
width: 100%;
height: 18vh;
background-position: center;
background-size: 90%;
background-repeat: no-repeat;
${props => props.title === 'Staff Management' && css`
background-origin: border-box;
background-position: 85% 50%;
background-size: 35%;
`}
display: flex;
justify-content: flex-start;
${props => props.center && css`
justify-content: center;
`}
background-image: url('${props => props.background}');
box-shadow: 0px 10px 30px lightgray;
border-color: transparent;
border-radius: 15px;
margin: 20px auto;
padding: 0 20px;
align-items: center;
${props => props.title === 'Daily Summary' && css`
align-items: flex-start;
padding: 4vh 20px;
`}
${props => props.half && css`
padding: 4vh 10px;
`}

:hover {
    width: 101%;
    height: 20vh;
    box-shadow: 0px 3px 10px lightgray;
    margin: 12px auto;
}

@media screen and (min-width: 768px) {
    padding: 0 35px;

    ${props => props.title === 'Daily Summary' && css`
    padding: 4vh 35px;
    `}

    ${props => props.half && css`
    padding: 4vh 20px;
    `}
}

@media screen 
and (min-device-width: 1200px) 
and (max-device-width: 1600px) { 
    height: 21vh;
    margin: 15px auto;
    padding: 0 25px;

    ${props => props.title === 'Daily Summary' && css`
    padding: 4vh 25px;
    `}

    ${props => props.half && css`
    padding: 4vh 15px;
    `}

    :hover {
        height: 22vh;
    }
}

@media screen and (min-device-width: 1601px) {
    height: 21vh;
    margin: 15px auto;

    :hover {
        height: 22vh;
    }
}
`
// No need for media queries above 1600x

const StyledDiv2 = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
${props => props.center && css`
align-items: center;
`}
`

const StyledH1 = styled.h1`
font-size: 4.6vw;
${props => props.smalltext && css`
font-size: 4vw;
text-align: center;
`}
font-weight: 400;

>strong {
    font-weight: 600;
}

@media screen and (min-width: 480px) {
    font-weight: 300;
    font-size: 3vw;
    ${props => props.smalltext && css`
    font-size: 2vw;
    `}

    >strong {
        font-weight: 400;
    }
}

@media screen and (min-width: 768px) {
    font-size: 2vw;
    ${props => props.smalltext && css`
    font-size: 1.6vw;
    `}
}

@media only screen 
and (min-device-width: 768px) 
and (max-device-width: 1024px) 
and (orientation: portrait) {
    font-size: 4vw;
    ${props => props.smalltext && css`
    font-size: 3vw;
    `}
}

@media only screen 
and (min-device-width: 1024px) 
and (max-device-width: 1024px) 
and (min-device-height: 1366px) 
and (max-device-height: 1366px) 
and (min-width: 1024px) 
and (max-width: 1024px)
and (orientation: portrait) {
    font-size: 3vw;
    ${props => props.smalltext && css`
    font-size: 2.8vw;
    `}
}

@media screen 
and (min-device-width: 1200px) 
and (max-device-width: 1600px) {
    font-size: 1.7vw;
    ${props => props.smalltext && css`
    font-size: 1.5vw;
    `}
}

@media screen and (min-width: 1600px) {
    font-size: 30px;
    ${props => props.smalltext && css`
    font-size: 28px;
    `}
}
`

const StyledSub = styled.sub`
font-size: 2.8vw;
color: gray;
font-weight: 400;

@media screen and (min-width: 480px) {
    font-size: 2vw;
    font-weight: 200;
}

@media screen and (min-width: 768px) {
    font-size: 1.5vw;
}

@media only screen 
and (min-device-width: 768px) 
and (max-device-width: 1024px) 
and (orientation: portrait) {
    font-size: 2.25vw;
}

@media only screen 
and (min-device-width: 1024px) 
and (max-device-width: 1024px) 
and (min-device-height: 1366px) 
and (max-device-height: 1366px) 
and (min-width: 1024px) 
and (max-width: 1024px) {
    font-size: 1.6vw;
}

@media screen 
and (min-device-width: 1200px) 
and (max-device-width: 1600px) {
    font-size: 1.1vw;
}

@media screen and (min-width: 1600px) {
    font-size: 17px;
}
`

const StyledH2 = styled.h2`
font-size: 5.3vw;
font-weight: 200;
${props => props.error && css`
color: red;
`}

@media screen and (min-width: 480px) {
    font-size: 1.8vw;
}

@media only screen 
and (min-device-width: 768px) 
and (max-device-width: 1024px) 
and (orientation: portrait) {
    font-size: 5vw;
}

@media only screen 
and (min-device-width: 1024px) 
and (max-device-width: 1024px) 
and (min-device-height: 1366px) 
and (max-device-height: 1366px) 
and (min-width: 1024px) 
and (max-width: 1024px) {
    font-size: 4.8vw;
}

@media screen 
and (min-device-width: 1200px) 
and (max-device-width: 1600px) {
    font-size: 2.8vw;
}

@media screen and (min-width: 1600px) {
    font-size: 50px;
}
`


export const DesignerCard = props => {
    return <StyledDiv1 {...props}>
        <StyledDiv2 {...props}>
            <StyledH1 {...props}>{props.title}</StyledH1>
            {props.subhead && <StyledSub>{props.subhead}</StyledSub>}
            {props.loading
                ? <Loader />
                : props.subtitle && <StyledH2 {...props}>{props.subtitle}</StyledH2>
            }
        </StyledDiv2>
    </StyledDiv1>
}